export const emptyFunction = () => {
  /* empty function */
};
